export const BasicInfoAuthenticatedComponent = {
    template: `
        <oo-card id="ca-customer-basicinfo">
            <oo-card-header>
                <p>Contact Information</p>
            </oo-card-header>

            <oo-card-body>
                <oo-edit-pane
                    ng-if="!$ctrl.loading"
                    on-submit="$ctrl.onSubmit()"
                    on-cancel="$ctrl.onCancel()"
                    missing-data="$ctrl.missingData()"
                    >
                    <oo-read-state>
                        <p id="ca-customer-names" c-type="title-md-primary">{{$ctrl.data.basicInfo.firstName}} {{$ctrl.data.basicInfo.lastName}}</p>
                        <p id="ca-customer-email" c-type="title-md-primary">{{$ctrl.data.basicInfo.email}}</p>
                        <p id="ca-customer-phone-number" c-type="title-md-primary">{{$ctrl.data.basicInfo.phoneNumber}}</p>
                    </oo-read-state>
                    <oo-edit-state>
                        <div class="flex-row expand">
                            <add-basic-info disable-email="true"></add-basic-info>
                        </div>
                        <oo-alert ng-if="$ctrl.authenticationService.errorMessage" severity="error">
                            <oo-alert-message>{{$ctrl.authenticationService.errorMessage}}</oo-alert-message>
                        </oo-alert>
                    </oo-edit-state>
                </oo-edit-pane>
            </oo-card-body>
        </oo-card>
    `,
    bindings: {
        firstName: '<',
        lastName: '<',
        email: '<',
        phoneNumber: '<'
    },
    controller: class {
        constructor(accountService, checkoutService, basicInfoService, googleAnalyticsTrackingService, restaurantInfoFactory) {
            'ngInject';
            this.accountService = accountService;
            this.data = accountService.data;
            this.checkoutService = checkoutService;
            this.basicInfoService = basicInfoService;
            this.googleAnalyticsTrackingService = googleAnalyticsTrackingService;
            this.restaurantInfoFactory = restaurantInfoFactory;
            this.loading = true;
            this.isLoyaltyEnabled = false;
        }
        $onInit() {
            this.accountService.getBasicInfo()
                .then(() => {
                    const basicInfo = this.data.basicInfo;
                    this.basicInfoService.setBasicInfo(basicInfo);
                    this.checkoutService.setBasicInfo(basicInfo);
                })
                .finally(() => this.loading = false);
            this.restaurantInfoFactory.getInfo(['general'])
                .then(data => this.isLoyaltyEnabled = data.general.isLoyaltyEnabled);
        }
        $onChanges(changes) {
            Object.keys(changes).forEach(key => {
                this[key] = changes[key].currentValue;
            });
        }
        onCancel() {
            this.googleAnalyticsTrackingService.trackBasicInfo(false);

            this.basicInfoService.setBasicInfo(this.checkoutService.data.basicInfo);
        }
        missingData() {
            return !this.basicInfoService.isValid(this.checkoutService.data.basicInfo);
        }
        onSubmit() {
            this.googleAnalyticsTrackingService.trackBasicInfo(true);

            return this.accountService.setBasicInfo(this.basicInfoService.data)
                .then(() => this.checkoutService.setBasicInfo(this.basicInfoService.data));
        }
    }
};
